import type { SubscriptionPayloadV2 } from 'api/LESubscriptions'
import { get, remove, set } from 'lib/storage/isomorphicLocalStorage'

export const PENDING_SIGNUP_MARKETING_CHOICE_KEY = 'pendingSignupMarketingChoice'

export type PendingSignupMarketingChoice = Pick<SubscriptionPayloadV2, 'userId' | 'subscriptions' | 'source'>

function isPendingSignupMarketingChoice(value: unknown): value is PendingSignupMarketingChoice {
  if (!value || typeof value !== 'object') return false
  const choice = value as PendingSignupMarketingChoice
  return typeof choice.userId === 'string' &&
    choice.userId.length > 0 &&
    !!choice.subscriptions &&
    typeof choice.source === 'string'
}

// The retry record is best effort. Storage can throw (quota, blocked storage),
// and that must not stop the subscription write or the rest of sign-in.

/** Keep the signup choice until the subscription write succeeds. A missing row is treated as subscribed to every channel. */
export function rememberSignupMarketingChoice(choice: PendingSignupMarketingChoice) {
  try {
    set(PENDING_SIGNUP_MARKETING_CHOICE_KEY, choice)
  } catch {
    // Without a record, only a failed first write goes unretried.
  }
}

export function readSignupMarketingChoice(): PendingSignupMarketingChoice | undefined {
  try {
    const stored = get(PENDING_SIGNUP_MARKETING_CHOICE_KEY)
    return isPendingSignupMarketingChoice(stored) ? stored : undefined
  } catch {
    return undefined
  }
}

export function forgetSignupMarketingChoice() {
  try {
    remove(PENDING_SIGNUP_MARKETING_CHOICE_KEY)
  } catch {
    // A leftover record only replays a choice that is already saved.
  }
}
